<template>
    <div>
        <app-button :text="$t('create') + ' ' + $t('client')" icon="add" :disabled="disabled" @click="dialog = true" />

        <app-dialog
            v-if="!disabled"
            v-model="dialog"
            :title="$t('create') + ' ' + $t('client')"
            hide-actions
            size="x-large"
        >
            <v-divider class="my-2 hidden" />
            <create-client hide-header prepend-cancel-button @success="onSuccess" @cancel="dialog = false" />
        </app-dialog>
    </div>
</template>

<script>
export default {
    name: 'CreateClientButton',
    components: {
        AppDialog: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppDialog'
            ),
        CreateClient: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/forms/CreateClient'
            )
    },
    props: {
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        dialog: false
    }),
    methods: {
        onSuccess(response) {
            this.dialog = false;
            this.$emit('success', response);
        }
    }
};
</script>
